import React from 'react';
import {Box, Typography, IconButton} from '@mui/material';
import Grid from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';
import {styled} from '@mui/system';

import {lightenColor} from '../helpers/ColorUtils';
import {ROUNDING_MINUTES_FOR_SHIFT_TIME} from '../domain/ShiftPlanConstants';
import CompactTimePickerComponent from "./common/CompactTimePickerComponent";

export default function SelectedServiceTypeDetails({selectedServiceType, startTime, endTime, onStartTimeChange, onEndTimeChange, onRemoveService}) {

    const ServiceTypeBox = styled(Box)(() => ({
        border: '1px solid #ccc',
        borderRadius: '0.5rem',
        padding: '0.5rem',
        paddingTop: '0.7rem',
        marginTop: '0.5rem'
    }));

    const ServiceTypeColor = styled(Box)(() => ({
        width: 20,
        height: 20,
        backgroundColor: lightenColor(selectedServiceType.primaryColor)
    }));

    const ServiceTypeDescription = styled(Typography)(() => ({
        fontSize: 14,
        variant: 'body1'
    }));

    return (
      <ServiceTypeBox>
          <Grid container spacing={3.3} alignItems="center">
              <Grid size={1}><ServiceTypeColor/></Grid>
              <Grid size={3}>
                  <ServiceTypeDescription>{selectedServiceType.description}</ServiceTypeDescription>
              </Grid>
              <Grid size={3}>
                  <CompactTimePickerComponent
                    label={"Start Time"}
                    value={startTime}
                    roundingValue={ROUNDING_MINUTES_FOR_SHIFT_TIME}
                    onChange={onStartTimeChange}/>
              </Grid>
              <Grid size={3}>
                  <CompactTimePickerComponent
                    label={"End Time"}
                    value={endTime}
                    roundingValue={ROUNDING_MINUTES_FOR_SHIFT_TIME}
                    onChange={onEndTimeChange}/>
              </Grid>
              <Grid size={1} marginLeft={5}>
                  <IconButton onClick={onRemoveService} display="flex">
                      <CloseIcon/>
                  </IconButton>
              </Grid>
          </Grid>
      </ServiceTypeBox>
    );
}